/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable consistent-return */
import { Text } from '@leverege/ui-elements'
import moment from 'moment'
import React, { useMemo } from 'react'
import S from '../components/Tables.css'

const useEventsTable = ( props ) => {
  const { item } = props
  const jobId = item?.data?.finishedGoodsJob?.data?.jobId

  const getDuration = ( ms, hide = true ) => {
    const hour = Math.floor( ( Math.abs( ms ) / ( 1000 * 60 * 60 ) ) % 24 )
    const min = Math.floor( ( Math.abs( ms ) / 1000 / 60 ) % 60 )
    const sec = Math.floor( ( Math.abs( ms ) / 1000 ) % 60 )

    if ( hide ) return `${hour ? `${hour}h` : ''} ${min ? `${min}m ` : ''}${sec}s`
    return `${min}m ${sec}s`
  }

  const formatAvgs = ( avg ) => {
    if ( avg === undefined ) return '-'
    if ( avg === 0 ) return avg
    return Intl.NumberFormat( undefined, {
      minimumFractionDigits : 1,
    } ).format( avg )
  }

  const psData = useMemo( () => Object.entries(
    item?.data?.finishedGoodsJob?.data?.pressureSideJob?.data?.stage || {},
  ).map( ( [ k, { startTime, endTime, avgWorkerCountBySubcategory } ] ) => ( {
    routingCode : k,
    cycleStartTime : startTime ?
      moment( startTime ).format( 'YYYY-MM-DD HH:mm' ) :
      '-',
    cycleEndTime : endTime ? moment( endTime ).format( 'YYYY-MM-DD HH:mm' ) : '-',
    cycleDuration : getDuration( moment( endTime ).diff( startTime, 'ms' ) ),
    avgDirLaborProd : formatAvgs( avgWorkerCountBySubcategory?.productionAssociate ),
    avgDirLaborCrane : formatAvgs( avgWorkerCountBySubcategory?.craneOperator ),
    avgDirLaborTeam : formatAvgs( avgWorkerCountBySubcategory?.teamLeader ),
    avgDirLaborResin : formatAvgs( avgWorkerCountBySubcategory?.resinMachineOperator ),
    avgDirLaborTrainer : formatAvgs( avgWorkerCountBySubcategory?.trainer ),
    avgIndLaborProdSup : formatAvgs( avgWorkerCountBySubcategory?.supervisor ),
    avgIndLaborProdCtrl : formatAvgs( avgWorkerCountBySubcategory?.productionControl ),
    avgIndLaborQuality : formatAvgs( avgWorkerCountBySubcategory?.quality ),
    avgIndLaborTraining : formatAvgs( avgWorkerCountBySubcategory?.training ),
    avgIndLaborEng : formatAvgs( avgWorkerCountBySubcategory?.engineeringMaintenanceEhs ),
    avgUncategorized : formatAvgs( avgWorkerCountBySubcategory?.uncategorized ),
  } ) ), [ item?.data?.uwMold?.data?.subAssemblyJob?.data?.stage ] )

  const ssData = useMemo( () => Object.entries(
    item?.data?.finishedGoodsJob?.data?.suctionSideJob?.data?.stage || {},
  ).map( ( [ k, { startTime, endTime, avgWorkerCountBySubcategory } ] ) => ( {
    routingCode : k,
    cycleStartTime : startTime ?
      moment( startTime ).format( 'YYYY-MM-DD HH:mm' ) :
      '-',
    cycleEndTime : endTime ? moment( endTime ).format( 'YYYY-MM-DD HH:mm' ) : '-',
    cycleDuration : getDuration( moment( endTime ).diff( startTime, 'ms' ) ),
    avgDirLaborProd : formatAvgs( avgWorkerCountBySubcategory?.productionAssociate ),
    avgDirLaborCrane : formatAvgs( avgWorkerCountBySubcategory?.craneOperator ),
    avgDirLaborTeam : formatAvgs( avgWorkerCountBySubcategory?.teamLeader ),
    avgDirLaborResin : formatAvgs( avgWorkerCountBySubcategory?.resinMachineOperator ),
    avgDirLaborTrainer : formatAvgs( avgWorkerCountBySubcategory?.trainer ),
    avgIndLaborProdSup : formatAvgs( avgWorkerCountBySubcategory?.supervisor ),
    avgIndLaborProdCtrl : formatAvgs( avgWorkerCountBySubcategory?.productionControl ),
    avgIndLaborQuality : formatAvgs( avgWorkerCountBySubcategory?.quality ),
    avgIndLaborTraining : formatAvgs( avgWorkerCountBySubcategory?.training ),
    avgIndLaborEng : formatAvgs( avgWorkerCountBySubcategory?.engineeringMaintenanceEhs ),
    avgUncategorized : formatAvgs( avgWorkerCountBySubcategory?.uncategorized ),
  } ) ), [ item?.data?.uwMold?.data?.subAssemblyJob?.data?.stage ] )

  const bndData = useMemo( () => Object.entries(
    item?.data?.finishedGoodsJob?.data?.bondedBladeJob?.data?.stage || {},
  ).map( ( [ k, { startTime, endTime, avgWorkerCountBySubcategory } ] ) => ( {
    routingCode : k,
    cycleStartTime : startTime ?
      moment( startTime ).format( 'YYYY-MM-DD HH:mm' ) :
      '-',
    cycleEndTime : endTime ? moment( endTime ).format( 'YYYY-MM-DD HH:mm' ) : '-',
    cycleDuration : getDuration( moment( endTime ).diff( startTime, 'ms' ) ),
    avgDirLaborProd : formatAvgs( avgWorkerCountBySubcategory?.productionAssociate ),
    avgDirLaborCrane : formatAvgs( avgWorkerCountBySubcategory?.craneOperator ),
    avgDirLaborTeam : formatAvgs( avgWorkerCountBySubcategory?.teamLeader ),
    avgDirLaborResin : formatAvgs( avgWorkerCountBySubcategory?.resinMachineOperator ),
    avgDirLaborTrainer : formatAvgs( avgWorkerCountBySubcategory?.trainer ),
    avgIndLaborProdSup : formatAvgs( avgWorkerCountBySubcategory?.supervisor ),
    avgIndLaborProdCtrl : formatAvgs( avgWorkerCountBySubcategory?.productionControl ),
    avgIndLaborQuality : formatAvgs( avgWorkerCountBySubcategory?.quality ),
    avgIndLaborTraining : formatAvgs( avgWorkerCountBySubcategory?.training ),
    avgIndLaborEng : formatAvgs( avgWorkerCountBySubcategory?.engineeringMaintenanceEhs ),
    avgUncategorized : formatAvgs( avgWorkerCountBySubcategory?.uncategorized ),
  } ) ), [ item?.data?.uwMold?.data?.subAssemblyJob?.data?.stage ] )

  const columns = [
    {
      id : 'routingCode',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Engineering Routing Code
        </Text>
      ),
      accessor : item => item.routingCode,
    },
    {
      id : 'cycleStartTime',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Cycle Start Time
        </Text>
      ),
      accessor : item => item.cycleStartTime,
    },
    {
      id : 'cycleEndTime',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Cycle End Time
        </Text>
      ),
      accessor : item => item.cycleEndTime,
    },
    {
      id : 'cycleDuration',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Cycle Duration Time
        </Text>
      ),
      accessor : item => item.cycleDuration,
    },
    {
      id : 'avgDirLaborProd',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Average Direct Labor Production Associates
        </Text>
      ),
      accessor : item => item.avgDirLaborProd,
    },
    {
      id : 'avgDirLaborCrane',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Average Direct Labor Crane Operators
        </Text>
      ),
      accessor : item => item.avgDirLaborCrane,
    },
    {
      id : 'avgDirLaborTeam',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Average Direct Labor Team Leaders
        </Text>
      ),
      accessor : item => item.avgDirLaborTeam,
    },
    {
      id : 'avgDirLaborResin',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Average Direct Labor Resin Machine Operator
        </Text>
      ),
      accessor : item => item.avgDirLaborResin,
    },
    {
      id : 'avgDirLaborTrainer',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Average Direct Labor On-the-Job Trainer
        </Text>
      ),
      accessor : item => item.avgDirLaborTrainer,
    },
    {
      id : 'avgIndLaborProdSup',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Average Indirect Labor Production Supervisor
        </Text>
      ),
      accessor : item => item.avgIndLaborProdSup,
    },
    {
      id : 'avgIndLaborProdCtrl',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Average Indirect Labor Production Control
        </Text>
      ),
      accessor : item => item.avgIndLaborProdCtrl,
    },
    {
      id : 'avgIndLaborQuality',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Average Indirect Labor Quality
        </Text>
      ),
      accessor : item => item.avgIndLaborQuality,
    },
    {
      id : 'avgIndLaborTraining',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Average Indirect Labor Training
        </Text>
      ),
      accessor : item => item.avgIndLaborTraining,
    },
    {
      id : 'avgIndLaborEng',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Average Indirect Labor Engineering / Maintenance / EHS
        </Text>
      ),
      accessor : item => item.avgIndLaborEng,
    },
    {
      id : 'avgUncategorized',
      Header : (
        <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">
          Average Uncategorized
        </Text>
      ),
      accessor : item => item.avgUncategorized,
    },
  ]

  return {
    jobId,
    psData,
    ssData,
    bndData,
    columns,
  }
}

export default useEventsTable
